import React from 'react';

import ReactDOM from 'react-dom';

import * as Sentry from '@sentry/browser';

import { ErrorPage } from '@qality/common-pages';
import { ErrorReportingService, FlagService } from '@qality/common-service';

import HostNameService from './HostNameService';

export default {
  async handleError(
    error: Error,
    message: string,
    title = 'Something apparently went wrong. Your error message is:',
    actions = null
  ): Promise<void> {
    await HostNameService.init();

    Sentry.withScope((scope) => {
      let errObject = error;
      const errorDetails = ErrorReportingService.getDetails(error, message);

      if (!(errObject instanceof Error)) {
        errObject = new Error(message);
        errObject.name = errorDetails;
        errObject.message = message;
      }

      scope.setTag('errorType', 'flagMinorError');
      scope.setTag('hostname', HostNameService.baseUrl);
      scope.setExtra('errorMessage', errorDetails);
      scope.setExtra('message', message);
      scope.setLevel('error');

      Sentry.captureException(errObject);
    });

    FlagService.createFlag(title, message, 'error', actions);
  },
  async handleCriticalError(error: Error, message: string): Promise<void> {
    const errorDetails = ErrorReportingService.getDetails(error, message);
    await HostNameService.init();

    Sentry.withScope((scope) => {
      scope.setTag('errorType', 'renderErrorPage');
      scope.setTag('hostname', HostNameService.baseUrl);
      scope.setExtra('errorMessage', errorDetails);
      scope.setExtra('message', message);
      scope.setLevel('fatal');

      let errObject = error;

      if (!(errObject instanceof Error)) {
        errObject = new Error(message);
        errObject.name = errorDetails;
        errObject.message = message;
      }

      Sentry.captureException(errObject);
    });

    const container = document.getElementById(
      'com_soldevelo_apps_test-management_container'
    );
    if (container) {
      ReactDOM.render(
        <ErrorPage
          error={error}
          errorDetails={errorDetails}
          message={message}
        />,
        container
      );
    }
  },
};
